import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="grid min-h-screen place-items-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5 border border-[rgba(152,191,162,0.2)] bg-[#0b120e] p-8">
        <Link to="/" data-testid="admin-login-home-link"><Logo testid="admin-login-logo" /></Link>
        <div>
          <p className="eyebrow mt-6">Area riservata</p>
          <h1 className="font-display text-4xl font-900 uppercase">Accesso admin</h1>
        </div>
        <Input data-testid="admin-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 bg-[#050807]" />
        <Input data-testid="admin-password-input" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 bg-[#050807]" />
        {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
        <button data-testid="admin-login-btn" disabled={loading}
          className="flex w-full items-center justify-center gap-2 bg-[#98bfa2] py-4 font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca] disabled:opacity-50">
          {loading && <Loader2 className="animate-spin" size={18} />} Entra
        </button>
      </form>
    </main>
  );
}
